import { jsx as _jsx } from "react/jsx-runtime";
import { CommonLocationPage } from "../../../components/CommonLocationPage";
import { AppSection } from "../../../slices/app/types";
export const RetailLocationPage = () => {
    return _jsx(CommonLocationPage, { section: AppSection.Retail });
};
